<template>
  <section class="section is-marginless">

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="First Name">
          <b-input size="is-medium" placeholder="Enter your first name" ref="first_name" v-model="contact.first_name"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Last Name">
          <b-input size="is-medium" placeholder="Enter your last name" ref="last_name" v-model="contact.last_name"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Email Address">
          <b-input size="is-medium" placeholder="Enter your email address" ref="email" v-model="contact.email"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <label class="label">Phone Number</label>
        <b-field>
          <b-input size="is-medium" placeholder="Enter your phone number" ref="phone" v-model="contact.phone"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
          <b-field label="State">
                <b-select placeholder="Select a state" size= "is-medium" v-model="contact.state" ref="state">
                    <option v-for= "option in states_list" :key="option.id">
                      {{option}}
                    </option>
                </b-select>
          </b-field>
      </div>
    </div>

    <div class="columns is-centered">
        <div class="column is-half">
          <b-field label="# of Locations">
              <b-input size="is-medium" placeholder="Enter number" ref="number_of_locations" v-model="contact.number_of_locations"></b-input>
          </b-field>
        </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field class= "label" label="What POS provider are you using or planning to use if you have a retail store ?">
            <b-select placeholder="Select a provider" size= "is-medium" v-model="contact.point_of_sale_provider" ref="point_of_sale_provider">
                <option value="Biotrack">Biotrack</option>
                <option value="Blaze">Blaze</option>
                <option value="Brytemap">Brytemap</option>
                <option value="COVA">COVA</option>
                <option value="Flowhub">Flowhub</option>
                <option value="Greenbits">Greenbits</option>
                <option value="Greenline">Greenline</option>
                <option value="IndicaOnline">IndicaOnline</option>
                <option value="Leaf Logix">Leaf Logix</option>
                <option value="MJ Freeway">MJ Freeway</option>
                <option value="Portal 42">Portal 42</option>
                <option value="Treez">Treez</option>
                <option value="TH Suite">TH Suite</option>
                <option value="Other">Other</option>
            </b-select>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field class= "label" label="If currently operating, which ecommerce solution do you use?">
            <b-select placeholder="Select an ecommerce solution" size= "is-medium" v-model="contact.current_ecommerce_solution" ref="current_ecommerce_solution">
                <option value="Dutchie">Dutchie</option>
                <option value="Jane">Jane</option>
                <option value="Tymber">Tymber</option>
                <option value="WM orders">WM orders</option>
                <option value="Flowhub">Flowhub</option>
                <option value="WM Store">WM Store</option>
                <option value="Custom eCommerce">Custom eCommerce</option>
                <option value="Other">Other</option>
            </b-select>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <b-field label="Message">
          <b-input type="textarea" size="is-medium" placeholder="" ref="message" v-model="contact.message"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-half">
        <a class="button is-medium is-link is-half" @click="send" v-bind:class="{ 'is-loading': is_loading }" v-bind:dir="is_loading">Send Message</a>
      </div>
    </div>

  </section>
</template>

<script>
  import ContactService from './service'
  import { ToastProgrammatic as Toast } from 'buefy'

  export default {

    name: 'Contact',

    data () {
      return {
        error_message: null,
        contact: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          state: null,
          number_of_locations: null,
          point_of_sale_provider: null,
          current_ecommerce_solution: null,
          message: null,
          from_domain: this.$route.query.from_domain
        },
        is_loading: false,
        states_list: {
          AK: "Alabama",
          AL: "Alaska",
          AR: "Arkansas",
          AZ: "Arizona",
          CA: "California",
          CO: "Colorado",
          CT: "Connecticut",
          DE: "Delaware",
          FL: "Florida",
          GA: "Georgia",
          HI: "Hawaii",
          IA: "Iowa",
          ID: "Idaho",
          IL: "Illinois",
          IN: "Indiana",
          KS: "Kansas",
          KY: "Kentucky",
          LA: "Louisiana",
          MA: "Massachusetts",
          MD: "Maryland",
          ME: "Maine",
          MI: "Michigan",
          MN: "Minnesota",
          MO: "Missouri",
          MS: "Mississippi",
          MT: "Montana",
          NC: "North Carolina",
          ND: "North Dakota",
          NE: "Nebraska",
          NH: "New Hampshire",
          NJ: "New Jersey",
          NM: "New Mexico",
          NV: "Nevada",
          NY: "New York",
          OH: "Ohio",
          OK: "Oklahoma",
          OR: "Oregon",
          PA: "Pennsylvania",
          RI: "Rhode Island",
          SC: "South Carolina",
          SD: "South Dakota",
          TN: "Tennessee",
          TX: "Texas",
          UT: "Utah",
          VA: "Virginia",
          VT: "Vermont",
          WA: "Washington",
          WI: "Wisconsin",
          WV: "West Virginia",
          WY: "Wyoming",
        }
      }
    },

    mounted(){


    },

    methods: {

      send(){
        this.is_loading = true;

        console.log("contact", this.contact)

        if (!this.contact.first_name){
          this.$refs.first_name.focus()
          return this.throwError('Please enter your first name')
        }

        if (!this.contact.last_name){
          this.$refs.last_name.focus()
          return this.throwError('Please enter your last name')
        }

        if (!this.contact.email){
          this.$refs.email.focus()
          return this.throwError('Please enter a valid email address')
        }

        if (!this.contact.phone){
          this.$refs.phone.focus()
          return this.throwError('Please enter a valid phone number')
        }

        if (!this.contact.state){
          this.$refs.state.focus()
          return this.throwError('Please select state')
        }

        if (!this.contact.number_of_locations){
          this.$refs.number_of_locations.focus()
          return this.throwError('Please enter a valid amount of locations')
        }

        if (!this.contact.message){
          this.$refs.message.focus()
          return this.throwError('Please enter a message')
        }

        ContactService.send(this.contact, (err, company) => {

          this.is_loading = false;

          if (err){
            Toast.open({type: 'is-danger', message: err.message})
            return;
          }

          Toast.open({type: 'is-success', message: `Message sent successfully`})
          this.$router.push({name: 'ContactSuccess'})

        })

      },

      throwError(message){
        this.is_loading = false;
        Toast.open({type: 'is-danger', message})
      }

    }

  }

</script>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue